<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { parseLogFilterParams } from '../model/filters/parse-log-filter-params'
import { useKanbanTaskShowApi } from '../api/kanban-task-show.hook'
import { useTasksKanbanLogsApi } from '../api/logs.hook'
import TasksKanbanLog from './TasksKanbanLog.vue'

defineOptions({
  name: 'TasksKanbanLogPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const id = route.params.id
  if (typeof id !== 'string' || !id) return

  const params = parseLogFilterParams(route.query)

  void useKanbanTaskShowApi({ id })
  void useTasksKanbanLogsApi({ id, params })
})
</script>

<template>
  <TasksKanbanLog />
</template>
